/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownDisabilityType } from '../models/db_DropdownDisabilityType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DisabilityTypes {
    /**
     * Get a list of disability types
     * @returns db_DropdownDisabilityType OK
     * @throws ApiError
     */
    public static listDisabilityTypes(): CancelablePromise<Array<db_DropdownDisabilityType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/disability-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
